import type { ComponentType, ReactElement } from 'react';

import { paths } from '@/navigation/paths';
import { IndexPage } from '@/pages/IndexPage';
import { AddClientPage } from '@/pages/AddClientPage';
import { ClientProfilePage } from '@/pages/ClientProfilePage';
import { ClientHistoryPage } from '@/pages/ClientHistoryPage';
import { ClientPastPassesPage } from '@/pages/ClientPastPassesPage';
import { PassEditorPage } from '@/pages/PassEditorPage';
import { ProfilePage } from '@/pages/ProfilePage';

interface Route {
  path: string;
  Component: ComponentType;
  title?: string;
  icon?: ReactElement;
}

export const routes: Route[] = [
  { path: paths.home(), Component: IndexPage },
  { path: paths.addClient(), Component: AddClientPage },
  { path: paths.clientProfilePattern, Component: ClientProfilePage },
  { path: paths.clientHistoryPattern, Component: ClientHistoryPage },
  { path: paths.clientPastPassesPattern, Component: ClientPastPassesPage },
  { path: paths.passEditor(), Component: PassEditorPage },
  { path: paths.profile(), Component: ProfilePage },
];
